import ControlPanel from '../ControlPanel/ControlPanel';
import style from './Customer.module.css';
import CustomerList from './CustomerList/CustomerList';
import useCustomerLogic from './hooks/useCustomerLogic';

const Customer = () => {
  const {
    sortingLogo,
    isRotated,
    allClients,
    observerTarget,
    searchResults,
    isSearching,
    isExporting,
    handleSortArrowClick,
    toggleSortingDirection,
    handleSearchChange,
    handleExportExcel,
    updateClientCommentLocal,
    setIsSearching,
  } = useCustomerLogic();

  const displayedClients = isSearching ? searchResults : allClients;

  return (
    <div className={style.customer}>
      <ControlPanel
        setIsSearching={setIsSearching}
        onSearch={handleSearchChange}
        onExport={handleExportExcel}
        isExporting={isExporting}
      />
      <CustomerList
        clients={displayedClients}
        sortingLogo={sortingLogo}
        isRotated={isRotated}
        toggleSortingDirection={toggleSortingDirection}
        handleSortArrowClick={handleSortArrowClick}
        observerTarget={observerTarget}
        isSearching={isSearching}
        onCommentSaved={updateClientCommentLocal}
      />
    </div>
  );
};

export default Customer;
